export default __webpack_public_path__ + "static/media/billboard_landscape_reduced.236b6277.jpg";